export function getButtonText(value: string, t: (key: string) => string): string {
    switch (value) {
        case 'auth':
            return t("Test Connection");
        case 'fetch_samples':
            return t("Fetch Data");
        case 'show_permissions':
            return t("Request Information");
        case 'reset_cached_vessel_data':
            return t("Clear State");
        case 'view_cached_vessel_data':
            return t("Get State");
        default:
            return t("Test Action");
    }
}

export function getResponseText(value: string, testActionResponse: any, t: (key: string) => string): any[] {
    if (testActionResponse?.error) {
        return [t("Action Failed"), false];
    }
    switch (value) {
        case 'auth':
            return testActionResponse.valid_credentials ? [t("Valid Credentials"), true] : [t("Invalid Credentials"), false];
        case 'fetch_samples':
            return (testActionResponse.observations.length > 0) ? [t("Fetch Successful"), true] : [t("Fetch Unsuccessful"), false];
        case 'show_permissions':
            return (testActionResponse.data) ? [t("Click on 'View Details' to see the permissions."), true] : [t("Fetch Unsuccessful"), false];
        default:
            if (testActionResponse?.error) {
                return [t("Action Failed"), false];
            }
            return [t("Response Received"), null];
    }
}